export enum AuthActionTypes {
  Login = "[User Component] User login",
  LoginSuccess = "[User Component] User loging success",
  LoginFailed = "[User Component] User loging failed",
  Logout = "[User Component] User logout",

  Register = "[User Component] User register",
  RegisterResponse = "[User Component] User register response",
  RegisterFailed = "[User Component] User register failed",

  Recovery = "[User Component] User account recovery",
  RecoveryFailed = "[User Component] User account recovery failed",
  RecoverySuccess = "[User Component]  User account recovery success",

  ResetAuthErrorMessage = "[User Component] Reset auth error message",
}

export enum UserActionTypes {
  SaveUserInfo = "[User Component] Save user info",
  SaveUserInfoSuccess = "[User Component] Save user info success",
  SaveUserInfoFailed = "[User Component] Save user info failed",
  UpdatePointsCount = "[User Component] Points Count updated",
  HideExpiringMbcNotification = "[User Component] Hide expiring notification",
  HideExpiringMbcNotificationSuccess = "[User Component] Hide expiring notification success",
  HideExpiringMbcNotificationFailed = "[User Component] Hide expiring notification failed"
}

export enum ButtonSelectionActionTypes {
  StatusBarModuleSelected = "[Buttons Component] Status bar module selected",
  FreeToPlayModuleSelected = "[Buttons Component] Free to play module selected",
  BettingTasksModuleSelected = "[Buttons Component] Betting tasks module selected",
  JackpotModuleSelected = "[Buttons Component] Jackpot module selected",
  BettingTabSelected = "[Buttons Component] Betting tab selected",
  VouchersModuleSelected = "[Buttons Component] Vouchers module selected",
  FilterVouchersByCategory = "[Buttons Component] Filter vouchers by category",
  DisableTaskBarButtonNavigation = "[Buttons Component] Task-Bar buttons disabled"
}